<template>
<div>
  <v-card class="shadow">
    <TableHeader 
    title="کاربران شرکت" 
    @updateSelect="(e) => headersSelected = e" 
    :notFilter="true"      
    :notExcl="true"      
    v-model="search" 
    />
    <v-data-table
        :headers="headers"
        :items="companyUser"
        :search="search"
    >
      <template v-slot:item.operations="{ item }">
          <v-btn v-if="item.user.status == false" @click="changeStatus(item.user.id)" class="whiteButton btn_index">
فعال شود
          </v-btn>
        <v-btn v-if="item.user.status == true" @click="changeStatus(item.user.id)" class="whiteButton btn_index">غیر فعال شود</v-btn>
      </template>
    </v-data-table>
  </v-card>
</div>
</template>

<script>
import axiosApi from "@/plugins/axios";
import TableHeader from "@/components/Table/TableHeader.vue";

export default {
  name: "index",
  components: { TableHeader },
  data(){
    return {
      search : '',
      items: [
        {
          text: this.$route.meta,
          disabled: true,
          href: '/',
        },
      ],
      headers : [
        {
          text: 'نام',
          align: 'start',
          filterable: false,
          value: 'name',
        },
        { text: 'فامیل', value: 'family' },
        { text: 'کد ملی', value: 'nationalId' },
        { text: 'موبایل', value: 'user.mobile' },
        { text: 'عملیات', value: 'operations' },
      ],
      companyUser : []
    }
  },
  mounted() {
    this.userCompany()
  },
  methods : {
    userCompany()
    {
      axiosApi().post('v2/admin/company/companyUsers',{
        'company_id' : this.$route.params.companyId
      }).then((result)=>{
        this.companyUser = result.data.data.companyUser
      })
    },
    changeStatus(id)
    {
      axiosApi().post('v2/admin/driver/changeStatus',{
        'id' : id
      }).then(()=>{
        this.userCompany()
      })
    }
  }
}
</script>

<style scoped>

</style>
